import { DetailedHTMLProps, HTMLAttributes, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/features/theme-switch';

interface ITagProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title: string;
  color: string;
  marker?: boolean;
  withoutBg?: boolean;
}

export default function Tag({
  title,
  color,
  marker = false,
  withoutBg = false,
  ...props
}: ITagProps) {
  const { darkTheme } = useTheme();

  const opacity = useMemo(() => (darkTheme ? 0.2 : 0.04), [darkTheme]);

  return (
    <div
      {...props}
      className={twMerge(
        'relative w-fit overflow-hidden rounded',
        props.className
      )}
    >
      <div
        style={{
          color,
        }}
        className="relative z-10 flex items-center justify-center gap-x-2 px-2 py-[5px]"
      >
        {marker && <div className="h-1 w-1 rounded-full border-[0.8px]" />}
        <span>{title}</span>
      </div>
      <div
        style={{
          background: withoutBg ? 'transparent' : color,
          opacity,
        }}
        className="absolute -inset-1 bg-blue"
      />
    </div>
  );
}
